/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------

==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)


import moduleAuth from './auth/moduleAuth.js'
import modulePayment from './payments/modulePayment.js'
import moduleMunicipalitie from '@/store/municipalities/moduleMunicipalitie'
import moduleStatistics from '@/store/statistics/moduleStatistics'
import moduleTerminals from '@/store/terminals/moduleTerminals'


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    municipalities: moduleMunicipalitie,
    statistics: moduleStatistics,
    teminals:moduleTerminals,
    payments:modulePayment
  },
  strict: process.env.NODE_ENV !== 'production'
})
